import routeService from '../../services/route_service.js';
import AlertService from '../../services/alert_service.js';
import GeneralService from '../../services/general_service.js';
import LoginService from '../../services/login_service.js';
import ObraSocialService from '../../services/obras_sociales_service.js';

import Pacientes from '../../components/pacientes/admin_pacientes.vue';
import PacienteService from '../../services/paciente_service.js';

const alertService = new AlertService();
const loginService = new LoginService();
const generalService = new GeneralService();
const pacienteService = new PacienteService();
const obraSocialService = new ObraSocialService();
let _this = null;
export default {
	name: 'pacientes',
	components: { Pacientes },
	data: function() {
		return {
			titulo: 'PACIENTES',
			loginService: loginService,
			maxPage: 0,
			parent: this,		
			columns: [
				{key: 'idPaciente', value: 'Id'},
				{key: 'nombrePaciente', value: 'Nombre'},
				{key: 'apellidoPaciente', value: 'Apellido'},
				{key: 'dniPaciente', value: 'Dni'},
				{key: 'edadPaciente', value: 'Edad'},
				{key: 'sexoPaciente', value: 'Sexo'},
				//{key: 'nombreObraSocialPaciente', value: 'Obra Social'},
				//{key: 'sedePaciente', value: 'Sede'},
				{key: 'nroHcPaciente', value: 'Historias clinicas'},
				{key: 'fechaNacimientoPaciente', value: 'Fecha Nacimiento'},
				{key: 'statusPaciente', value: 'Internado'},
				{key: 'cantidadCirugias', value: 'Cirugias'},
				// {key: 'activoPaciente', value: 'Activo'}
			],
			actions: [{
				icon: 'search',
				name: 'Ver',
				actionBtn: this.verPaciente,
				buttonClass: 'btn btn-xs btn-light',
				hide: function() { return true }
			},{
				icon: 'pencil',
				name: 'Editar',
				actionBtn: this.editar,
				buttonClass: 'btn btn-xs btn-secondary',
				hide: function() { return true }
			},{
				icon: 'x',
				name: 'Desactivar',
				actionBtn: this.desactivar,
				buttonClass: 'btn btn-xs btn-danger',
				hide: function(item) { return item.activoPaciente == 'SI' }
			},{
				icon: 'check-circle',
				name: 'Activar',
				actionBtn: this.activar,
				buttonClass: 'btn btn-xs btn-info',
				hide: function(item) { return item.activoPaciente == 'NO' }
			},{
				icon: 'cart-plus',
				name: 'Internaciones',
				actionBtn: this.internacionesPaciente,
				buttonClass: 'btn btn-xs btn-warning',
				hide: function() { return true }
			},{
				icon: 'tag',
				name: 'Cirugias',
				actionBtn: this.cirugiasPaciente,
				buttonClass: 'btn btn-xs btn-dark',
				hide: function() { return true }
			}]
		}
	},
	created: function () {
		_this = this;
		this.submited = false;
		if(!loginService.hasPermission("listado", "pacientes")) {
			routeService.goToHome();
			return;
		}
		/*this.getObrasSociales();
		this.getData();*/
	},
	methods: { 
		getData: function () {
			this.buscando = true;
			pacienteService.countPacientes(this.search).then(function(response) {
				_this.maxPage = 0;
				if(response.body) {
					_this.maxPage = response.body;
				}
			});
			pacienteService.get(this.search).then(function(response) {
				_this.buscando = false;
				_this.data = [];
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						_this.data.push({
							idPaciente: value.idPaciente,
							nombrePaciente: value.nombrePaciente,
							apellidoPaciente: value.apellidoPaciente,
							dniPaciente: value.dniPaciente,
							obraSocialPaciente: value.obraSocialPaciente.nombreObraSocial,
							sedePaciente: value.sedePaciente.nombreSede,
							idSedePaciente: value.idSedePaciente,
							idHcPaciente: value.idHcPaciente,
							statusPaciente: value.statusPaciente,
							cantidadCirugias: value.cantidadCirugias ? value.cantidadCirugias : "NO",
							nroHcPaciente: value.nroHcPaciente,
							sexoPaciente: value.sexoPaciente == 1 ? 'M' : 'F',
							fechaNacimientoPaciente: generalService.fechaSpanish(value.fechaNacimientoPaciente),
							edadPaciente: value.edadPaciente,
							activoPaciente: value.activoPaciente == 1 ? 'SI' : 'NO',
							col1Paciente: value.col1Paciente,
							col2Paciente: value.col2Paciente,
							col3Paciente: value.col3Paciente,
						}); 
					} 
				} 
			}, function(error) { 
				_this.buscando = false;
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		getObrasSociales: function() {
			_this.obrasSociales = [];
			obraSocialService.get({}).then(function(response) {					
				if(response.body == null) {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', 'Ocurrio un error al obtener los datos');
					return;
				}
				if(response.body && response.body.status == 'ERROR') {
					alertService.showAlert(_this.$bvModal, 'danger', 'Error!', response.body.message);
					return;
				}
				if(response.body.length > 0) {
					for (let value of response.body) {
						if(value.activoObraSocial == 1) {
							_this.obrasSociales.push(value);
						}
					}
				} 
			}, function(error) { 
				_this.submited = false;
				generalService.showRequestErrors(error, _this.$bvModal);
				return;
			});
		},
		async desactivar(item) {
			try {
				if(!loginService.hasPermission("eliminar", "pacientes")) {
					routeService.goToHome();
					return;
				}
				let conf = await alertService.showConfirm(_this.$bvModal, 'warning', 'Confirmar', '¿Esta seguro que desea desactivar el registro id: ' + item.idPaciente + '?');
				if(conf) {
					_this.submited = true;
					pacienteService.remove({id: item.idPaciente}).then(function(response) {
						_this.submited = false; 
						if(response.body && response.body.status == 'success') {
							item.activoPaciente = 'NO';
							alertService.showAlert(_this.$bvModal, 'success', 'Confirmación!', 'Registro desactivado con exito.');
						}
					}, function(error) { 
						_this.submited = false;
						generalService.showRequestErrors(error, _this.$bvModal);
						return;
					});
				} 
			} catch(err) {
				return err;
			}
		}, 
		async activar(item) {
			try {
				if(!loginService.hasPermission("activar", "pacientes")) {
					routeService.goToHome();
					return;
				}
				let conf = await alertService.showConfirm(_this.$bvModal, 'warning', 'Confirmar', '¿Esta seguro que desea activar el registro id: ' + item.idPaciente + '?');
				if(conf) {
					_this.submited = true;
					pacienteService.activate({id: item.idPaciente}).then(function(response) {
						_this.submited = false; 
						if(response.body && response.body.status == 'success') {
							item.activoPaciente = 'SI';
							alertService.showAlert(_this.$bvModal, 'success', 'Confirmación!', 'Registro activado con exito.');
						}
					}, function(error) { 
						_this.submited = false;
						generalService.showRequestErrors(error, _this.$bvModal);
						return;
					});
				} 
			} catch(err) {
				return err;
			}
		}, 
		agregar: function () {
			if(!loginService.hasPermission("alta", "pacientes")) {
				routeService.goToHome();
				return;
			}
			routeService.goTo('paciente');
		},
		editar: function (item) {
			if(!loginService.hasPermission("editar", "pacientes")) {
				routeService.goToHome();
				return;
			}
			routeService.goTo('paciente/' + item.idPaciente);
		},
		verPaciente: function (item) {
			if(!loginService.hasPermission("listado", "pacientes")) {
				routeService.goToHome();
				return;
			}
			routeService.goTo('ver-paciente/' + item.idPaciente);
		},
		internacionesPaciente: function (item) {
			routeService.goTo('Internaciones', {idPacienteInternacion: item.idPaciente}, true);
		},
		cirugiasPaciente: function (item) {
			routeService.goTo('Cirugias', {idPacienteInternacion: item.idPaciente}, true);
		}
	}
}

